import { Fetcher } from "../Fetcher";
type Params = Record<string, any>;

export class AdditionalFileService extends Fetcher {
  static INSTANCE = new AdditionalFileService();

  constructor() {
    super();
  }

  async addAdditionalFile(
    applicationName: string,
    additionalFileName: string,
    additionalFile: File | undefined,
    params: Params,
  ): Promise<string> {
    return this.post(
      `applications/${applicationName}/additionalFiles/${additionalFileName}`,
      {
        file: additionalFile,
        params: JSON.stringify(params),
      },
    );
  }
}
